function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F1",
  fillOpacity: 0.46,
  d: "M-9 0h1457v782H-9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M6 0h1442v782H6z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8,
  mask: "url(#colorfulBackground_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#colorfulBackground_svg__filter0_f_728_6900)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 684.224,
  cy: 1028.47,
  rx: 407.213,
  ry: 527.674,
  fill: "url(#colorfulBackground_svg__paint0_radial_728_6900)"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#colorfulBackground_svg__filter1_f_728_6900)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1198.39,
  cy: 920.466,
  rx: 324.365,
  ry: 419.667,
  fill: "url(#colorfulBackground_svg__paint1_radial_728_6900)"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#colorfulBackground_svg__filter2_f_728_6900)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: -37.636,
  cy: 125.774,
  rx: 324.365,
  ry: 419.667,
  fill: "url(#colorfulBackground_svg__paint2_radial_728_6900)",
  fillOpacity: 0.4
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#colorfulBackground_svg__filter3_f_728_6900)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1503.17,
  cy: 372.623,
  rx: 250.554,
  ry: 324.672,
  fill: "url(#colorfulBackground_svg__paint3_radial_728_6900)"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "colorfulBackground_svg__paint0_radial_728_6900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 527.674 -407.213 0 684.224 1028.47)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0FC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "colorfulBackground_svg__paint1_radial_728_6900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 419.667 -324.365 0 1198.39 920.466)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CF6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "colorfulBackground_svg__paint2_radial_728_6900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 419.667 -324.365 0 -37.636 125.774)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CF6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "colorfulBackground_svg__paint3_radial_728_6900",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 324.672 -250.554 0 1503.17 372.623)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "colorfulBackground_svg__filter0_f_728_6900",
  x: 221.681,
  y: 445.47,
  width: 925.085,
  height: 1166.01,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 27.665,
  result: "effect1_foregroundBlur_728_6900"
})), /*#__PURE__*/React.createElement("filter", {
  id: "colorfulBackground_svg__filter1_f_728_6900",
  x: 818.694,
  y: 445.47,
  width: 759.389,
  height: 949.993,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 27.665,
  result: "effect1_foregroundBlur_728_6900"
})), /*#__PURE__*/React.createElement("filter", {
  id: "colorfulBackground_svg__filter2_f_728_6900",
  x: -417.33,
  y: -349.222,
  width: 759.389,
  height: 949.993,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 27.665,
  result: "effect1_foregroundBlur_728_6900"
})), /*#__PURE__*/React.createElement("filter", {
  id: "colorfulBackground_svg__filter3_f_728_6900",
  x: 1197.29,
  y: -7.379,
  width: 611.768,
  height: 760.004,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 27.665,
  result: "effect1_foregroundBlur_728_6900"
})));

function SvgColorfulBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 782",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, /*#__PURE__*/React.createElement("mask", {
    id: "colorfulBackground_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 1442,
    height: 782
  }, _ref2), _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQ0MCA3ODIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSItOSIgd2lkdGg9IjE0NTciIGhlaWdodD0iNzgyIiBmaWxsPSIjRjVGNUYxIiBmaWxsLW9wYWNpdHk9IjAuNDYiIC8+CiAgICA8bWFzayBpZD0ibWFzazBfNzI4XzY5MDAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjYiIHk9IjAiCiAgICAgICAgd2lkdGg9IjE0NDIiIGhlaWdodD0iNzgyIj4KICAgICAgICA8cmVjdCB4PSI2IiB3aWR0aD0iMTQ0MiIgaGVpZ2h0PSI3ODIiIGZpbGw9IiNEOUQ5RDkiIC8+CiAgICA8L21hc2s+CiAgICA8ZyBtYXNrPSJ1cmwoI21hc2swXzcyOF82OTAwKSI+CiAgICAgICAgPGcgb3BhY2l0eT0iMC44Ij4KICAgICAgICAgICAgPGcgb3BhY2l0eT0iMC41IiBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzcyOF82OTAwKSI+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBjeD0iNjg0LjIyNCIgY3k9IjEwMjguNDciIHJ4PSI0MDcuMjEzIiByeT0iNTI3LjY3NCIKICAgICAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWxfNzI4XzY5MDApIiAvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDxnIG9wYWNpdHk9IjAuNSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZl83MjhfNjkwMCkiPgogICAgICAgICAgICAgICAgPGVsbGlwc2UgY3g9IjExOTguMzkiIGN5PSI5MjAuNDY2IiByeD0iMzI0LjM2NSIgcnk9IjQxOS42NjciCiAgICAgICAgICAgICAgICAgICAgZmlsbD0idXJsKCNwYWludDFfcmFkaWFsXzcyOF82OTAwKSIgLz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyBvcGFjaXR5PSIwLjUiIGZpbHRlcj0idXJsKCNmaWx0ZXIyX2ZfNzI4XzY5MDApIj4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGN4PSItMzcuNjM1NSIgY3k9IjEyNS43NzQiIHJ4PSIzMjQuMzY1IiByeT0iNDE5LjY2NyIKICAgICAgICAgICAgICAgICAgICBmaWxsPSJ1cmwoI3BhaW50Ml9yYWRpYWxfNzI4XzY5MDApIiBmaWxsLW9wYWNpdHk9IjAuNCIgLz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyBvcGFjaXR5PSIwLjUiIGZpbHRlcj0idXJsKCNmaWx0ZXIzX2ZfNzI4XzY5MDApIj4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGN4PSIxNTAzLjE3IiBjeT0iMzcyLjYyMyIgcng9IjI1MC41NTQiIHJ5PSIzMjQuNjcyIgogICAgICAgICAgICAgICAgICAgIGZpbGw9InVybCgjcGFpbnQzX3JhZGlhbF83MjhfNjkwMCkiIC8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIwX2ZfNzI4XzY5MDAiIHg9IjIyMS42ODEiIHk9IjQ0NS40NyIgd2lkdGg9IjkyNS4wODUiIGhlaWdodD0iMTE2Ni4wMSIKICAgICAgICAgICAgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIgLz4KICAgICAgICAgICAgPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiIC8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjI3LjY2NDkiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl83MjhfNjkwMCIgLz4KICAgICAgICA8L2ZpbHRlcj4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIxX2ZfNzI4XzY5MDAiIHg9IjgxOC42OTQiIHk9IjQ0NS40NyIgd2lkdGg9Ijc1OS4zODkiIGhlaWdodD0iOTQ5Ljk5MyIKICAgICAgICAgICAgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIgLz4KICAgICAgICAgICAgPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiIC8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjI3LjY2NDkiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl83MjhfNjkwMCIgLz4KICAgICAgICA8L2ZpbHRlcj4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIyX2ZfNzI4XzY5MDAiIHg9Ii00MTcuMzMiIHk9Ii0zNDkuMjIyIiB3aWR0aD0iNzU5LjM4OSIgaGVpZ2h0PSI5NDkuOTkzIgogICAgICAgICAgICBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CiAgICAgICAgICAgIDxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4IiAvPgogICAgICAgICAgICA8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIgLz4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMjcuNjY0OSIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzcyOF82OTAwIiAvPgogICAgICAgIDwvZmlsdGVyPgogICAgICAgIDxmaWx0ZXIgaWQ9ImZpbHRlcjNfZl83MjhfNjkwMCIgeD0iMTE5Ny4yOSIgeT0iLTcuMzc5MjgiIHdpZHRoPSI2MTEuNzY4IiBoZWlnaHQ9Ijc2MC4wMDQiCiAgICAgICAgICAgIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KICAgICAgICAgICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIC8+CiAgICAgICAgICAgIDxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIiAvPgogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyNy42NjQ5IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNzI4XzY5MDAiIC8+CiAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfcmFkaWFsXzcyOF82OTAwIiBjeD0iMCIgY3k9IjAiIHI9IjEiCiAgICAgICAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIgogICAgICAgICAgICBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDY4NC4yMjQgMTAyOC40Nykgcm90YXRlKDkwKSBzY2FsZSg1MjcuNjc0IDQwNy4yMTMpIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzAwRkZDQyIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDBGRkNDIiBzdG9wLW9wYWNpdHk9IjAiIC8+CiAgICAgICAgPC9yYWRpYWxHcmFkaWVudD4KICAgICAgICA8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MV9yYWRpYWxfNzI4XzY5MDAiIGN4PSIwIiBjeT0iMCIgcj0iMSIKICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiCiAgICAgICAgICAgIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE5OC4zOSA5MjAuNDY2KSByb3RhdGUoOTApIHNjYWxlKDQxOS42NjcgMzI0LjM2NSkiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjQ0NGRjY2IiAvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNDQ0ZGNjYiIHN0b3Atb3BhY2l0eT0iMCIgLz4KICAgICAgICA8L3JhZGlhbEdyYWRpZW50PgogICAgICAgIDxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQyX3JhZGlhbF83MjhfNjkwMCIgY3g9IjAiIGN5PSIwIiByPSIxIgogICAgICAgICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIKICAgICAgICAgICAgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgtMzcuNjM1NSAxMjUuNzc0KSByb3RhdGUoOTApIHNjYWxlKDQxOS42NjcgMzI0LjM2NSkiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjQ0NGRjY2IiAvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNDQ0ZGNjYiIHN0b3Atb3BhY2l0eT0iMCIgLz4KICAgICAgICA8L3JhZGlhbEdyYWRpZW50PgogICAgICAgIDxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQzX3JhZGlhbF83MjhfNjkwMCIgY3g9IjAiIGN5PSIwIiByPSIxIgogICAgICAgICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIKICAgICAgICAgICAgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxNTAzLjE3IDM3Mi42MjMpIHJvdGF0ZSg5MCkgc2NhbGUoMzI0LjY3MiAyNTAuNTU0KSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNDQzMzRkYiIC8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0NDMzNGRiIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgICAgIDwvcmFkaWFsR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgogICAg";
export { SvgColorfulBackground as ReactComponent };